<div class="slider-container">
  <div class="slider-row">
    <div class="slider-track">
      <nouislider #nouislider [config]="sliderConfig" (change)="onSliderChange($event)" (slide)="onSliderSlide($event)"
        [disabled]="disabled">
      </nouislider>
    </div>
    <div class="slider-value-display" *ngIf="showTooltip">
      <span class="value">{{ value }}</span>
    </div>
  </div>
</div>